// 说明：
//
// - `cooperationConsulting`: 是否展示合作咨询模块。
// - `internationalWebsite`: 是否展示国际官网选项。
// - `language`: 展示语言设置选项的多选框，每个选项对应一种语言，在这里我们将默认选择中文，而英语和法语是可选的。
// - `country`: 展示选择国家或地区的多选框，每个选项对应一个国家或地区，在这里我们将默认选择中国，并可选择美国和法国。
// - `officialWebsiteLogoText`：官网Logo和标语文本设置。可以指定图像URL和相应的文本。
// - `loginMethods`: 登录方式选项。展示四种登录方法：手机号码登录、邮件登录、短信验证码登录和使用QR码扫描登录。
// - `registerEnabled`: 是否展示立即注册按钮。
// - `helpCenterEnabled`: 是否展示帮助中心链接。

/**
 * 登录页配置项 配置登录页各个ui展示 和 模块功能是否启动
 * @type {{isOldLoginOn: boolean, cooperationConsulting: boolean, internationalWebsite: boolean, country: boolean, language: boolean, officialWebsiteLogoText: {default: string, "zh-CN": string, "zh-HK": string, en: string, "ja-JP": string, "ko-KR": string, "th-TH": string, "vi-VN": string}, loginMethods: {mobilePhoneLogin: boolean, emailLogin: boolean, usernameLogin: boolean, smsLogin: boolean, emailCodeLogin: boolean, wxQRCodeLogin: boolean}, isRegisterEnabled: boolean, isHelpCenterEnabled: boolean}}
 */
const config = {
  'isOldLoginOn': true, // 老登录页
  'cooperationConsulting': true, // 合作咨询
  'internationalWebsite': true, // 国际官网
  'country': true, // 国家
  'language': true, // 语言
  'officialWebsiteLogoText': {
    'default': 'ICAS',
    'zh-CN': '国际统一用户中心',
    'zh-HK': '國際統一用戶中心',
    'en': 'ICAS',
    'ja-JP': 'ICAS',
    'ko-KR': 'ICAS',
    'th-TH': 'ICAS',
    'vi-VN': 'ICAS'
  },
  'loginMethods': {
    'mobilePhoneLogin': true, // 手机号登录
    'emailLogin': true, // 邮箱密码登录
    'usernameLogin': true, // 用户名登录
    'smsLogin': true, // 短信验证码登录
    'emailCodeLogin': true, // 邮箱验证码登录
    'wxQRCodeLogin': true // 是否支持微信登录
  },
  'forgetPwdEnabled': true, // 忘记密码
  'isRegisterEnabled': true, // 有利也的立即注册按钮
  'isHelpCenterEnabled': true, // 登录页邮编的指引按钮
  'tiledLogo': null,
  'leftLogo': null,
  'rightLogo': null,
  'sfInternationalLogo': null,
  'tiledEnable': true,
  'leftDocuments': {
    'lang': '', // 语言
    'jumpUrl': '', // 跳转链接
    'jumpDocument': '', // 二维码
    'describe': '', // 描述
    'scanningWarn': '', // 扫描提示
    'codeLogo': '', // qrcode
  }
}

const ESGOSConfig = {
  'isOldLoginOn': true, // 老登录页
  'cooperationConsulting': true, // 合作咨询
  'internationalWebsite': true, // 国际官网
  'country': true, // 国家
  'language': true, // 语言
  termsOfServiceKey: 62,
  privacyPolicyKey: 63,
  cookieKey: 61,
  'officialWebsiteLogoText': {
    'default': 'Intl Open API',
    'zh-CN': '国际开放平台',
    'zh-HK': '國際開放平臺',
    'en': 'Intl Open API',
    'ja-JP': 'Intl Open API',
    'ko-KR': 'Intl Open API',
    'th-TH': 'Intl Open API',
    'vi-VN': 'Intl Open API'
  },
  'loginMethods': {
    'mobilePhoneLogin': true, // 手机号登录
    'emailLogin': true, // 邮箱密码登录
    'usernameLogin': true, // 用户名登录
    'smsLogin': true, // 短信验证码登录
    'emailCodeLogin': true, // 邮箱验证码登录
    'wxQRCodeLogin': true // 是否支持微信登录
  },
  'forgetPwdEnabled': true, // 忘记密码
  'isRegisterEnabled': false, // 有利也的立即注册按钮
  'isHelpCenterEnabled': true, // 登录页邮编的指引按钮
  'tiledLogo': null, // '/static/imgs/bg_kex.png',
  'leftLogo': null,
  'rightLogo': null,
  'sfInternationalLogo': null,
  'tiledEnable': true,
  'leftDocuments': {
    'lang': '', // 语言
    'jumpUrl': '', // 跳转链接
    'jumpDocument': '', // 二维码
    'describe': '', // 描述
    'scanningWarn': '', // 扫描提示
    'codeLogo': '', // qrcode
  },
  'theme': {
    loginBtnBg: '#f37024'
    // 'backgroundColor': '#F37021',
    // 'buttonBackgroundColor': '#ee5a1c',
    // 'backgroundSize': '60%',
    // footColor: '#fff'
  }
}

const IUOPOSconfig = {
  'isOldLoginOn': true, // 老登录页
  'cooperationConsulting': true, // 合作咨询
  'internationalWebsite': true, // 国际官网
  'country': true, // 国家
  'language': true, // 语言
  termsOfServiceKey: 62,
  privacyPolicyKey: 63,
  cookieKey: 61,
  'officialWebsiteLogoText': {
    'default': 'IUOP',
    'zh-CN': '国际统一订单平台',
    'zh-HK': '國際統一訂單平臺',
    'en': 'IUOP',
    'ja-JP': 'IUOP',
    'ko-KR': 'IUOP',
    'th-TH': 'IUOP',
    'vi-VN': 'IUOP'
  },
  'loginMethods': {
    'mobilePhoneLogin': true, // 手机号登录
    'emailLogin': true, // 邮箱密码登录
    'usernameLogin': true, // 用户名登录
    'smsLogin': true, // 短信验证码登录
    'emailCodeLogin': true, // 邮箱验证码登录
    'wxQRCodeLogin': true // 是否支持微信登录
  },
  'forgetPwdEnabled': true, // 忘记密码
  'isRegisterEnabled': true, // 有利也的立即注册按钮
  'isHelpCenterEnabled': true, // 登录页邮编的指引按钮
  'tiledLogo': null,
  'leftLogo': null,
  'rightLogo': null,
  'sfInternationalLogo': null,
  'tiledEnable': true,
  'leftDocuments': {
    'lang': '', // 语言
    'jumpUrl': '', // 跳转链接
    'jumpDocument': '', // 二维码
    'describe': '', // 描述
    'scanningWarn': '', // 扫描提示
    'codeLogo': '', // qrcode
  },
  // sfTheme: true
}
const IUOPOSIDconfig = {
  'isOldLoginOn': true, // 老登录页
  'cooperationConsulting': true, // 合作咨询
  'internationalWebsite': true, // 国际官网
  'country': true, // 国家
  'language': true, // 语言
  'officialWebsiteLogoText': {
    'default': 'IUOP',
    'zh-CN': '国际统一订单平台',
    'zh-HK': '國際統一訂單平臺',
    'en': 'IUOP',
    'ja-JP': 'IUOP',
    'ko-KR': 'IUOP',
    'th-TH': 'IUOP',
    'vi-VN': 'IUOP'
  },
  'loginMethods': {
    'mobilePhoneLogin': true, // 手机号登录
    'emailLogin': true, // 邮箱密码登录
    'usernameLogin': true, // 用户名登录
    'smsLogin': true, // 短信验证码登录
    'emailCodeLogin': true, // 邮箱验证码登录
    'wxQRCodeLogin': true // 是否支持微信登录
  },
  'forgetPwdEnabled': true, // 忘记密码
  'isRegisterEnabled': true, // 有利也的立即注册按钮
  'isHelpCenterEnabled': true, // 登录页邮编的指引按钮
  'tiledLogo': null,
  'leftLogo': null,
  'rightLogo': null,
  'sfInternationalLogo': null,
  'tiledEnable': true,
  'leftDocuments': {
    'lang': '', // 语言
    'jumpUrl': '', // 跳转链接
    'jumpDocument': '', // 二维码
    'describe': '', // 描述
    'scanningWarn': '', // 扫描提示
    'codeLogo': '', // qrcode
  },
  // sfTheme: true
}

const openAPIConfig = {
  'isOldLoginOn': true, // 老登录页
  'cooperationConsulting': true, // 合作咨询
  'internationalWebsite': true, // 国际官网
  'country': true, // 国家
  'language': true, // 语言
  'officialWebsiteLogoText': {
    'default': 'Intl Open API',
    'zh-CN': '国际开放平台',
    'zh-HK': '國際開放平臺',
    'en': 'Intl Open API',
    'ja-JP': 'Intl Open API',
    'ko-KR': 'Intl Open API',
    'th-TH': 'Intl Open API',
    'vi-VN': 'Intl Open API'
  },
  'loginMethods': {
    'mobilePhoneLogin': true, // 手机号登录
    'emailLogin': true, // 邮箱密码登录
    'usernameLogin': true, // 用户名登录
    'smsLogin': true, // 短信验证码登录
    'emailCodeLogin': true, // 邮箱验证码登录
    'wxQRCodeLogin': true // 是否支持微信登录
  },
  'forgetPwdEnabled': true, // 忘记密码
  'isRegisterEnabled': true, // 有利也的立即注册按钮
  'isHelpCenterEnabled': true, // 登录页邮编的指引按钮
  'tiledLogo': null,
  'leftLogo': null,
  'rightLogo': null,
  'sfInternationalLogo': null,
  'tiledEnable': true,
  'leftDocuments': {
    'lang': '', // 语言
    'jumpUrl': '', // 跳转链接
    'jumpDocument': '', // 二维码
    'describe': '', // 描述
    'scanningWarn': '', // 扫描提示
    'codeLogo': '', // qrcode
  }
}

const sdmConfig = {
  'isOldLoginOn': true, // 老登录页
  'cooperationConsulting': true, // 合作咨询
  'internationalWebsite': true, // 国际官网
  'country': true, // 国家
  'language': true, // 语言
  'officialWebsiteLogoText': {
    'default': 'SDM',
    'zh-CN': '保税智能制单系统',
    'zh-HK': '保稅智慧制單系統',
    'en': 'SDM',
    'ja-JP': 'SDM',
    'ko-KR': 'SDM',
    'th-TH': 'SDM',
    'vi-VN': 'SDM'
  },
  'loginMethods': {
    'mobilePhoneLogin': true, // 手机号登录
    'emailLogin': true, // 邮箱密码登录
    'usernameLogin': true, // 用户名登录
    'smsLogin': true, // 短信验证码登录
    'emailCodeLogin': true, // 邮箱验证码登录
    'wxQRCodeLogin': true // 是否支持微信登录
  },
  'forgetPwdEnabled': true, // 忘记密码
  'isRegisterEnabled': true, // 有利也的立即注册按钮
  'isHelpCenterEnabled': true, // 登录页邮编的指引按钮
  'tiledLogo': null,
  'leftLogo': null,
  'rightLogo': null,
  'sfInternationalLogo': null,
  'tiledEnable': true,
  'leftDocuments': {
    'lang': '', // 语言
    'jumpUrl': '', // 跳转链接
    'jumpDocument': '', // 二维码
    'describe': '', // 描述
    'scanningWarn': '', // 扫描提示
    'codeLogo': '', // qrcode
  }
}

const cbsConfig = {
  'isOldLoginOn': true, // 老登录页
  'cooperationConsulting': true, // 合作咨询
  'internationalWebsite': true, // 国际官网
  'country': true, // 国家
  'language': true, // 语言
  'officialWebsiteLogoText': {
    'default': 'CBS',
    'zh-CN': '丰凰航空货运平台',
    'zh-HK': '豐凰航空貨運平臺',
    'en': 'CBS',
    'ja-JP': 'CBS',
    'ko-KR': 'CBS',
    'th-TH': 'CBS',
    'vi-VN': 'CBS'
  },
  'loginMethods': {
    'mobilePhoneLogin': true, // 手机号登录
    'emailLogin': true, // 邮箱密码登录
    'usernameLogin': true, // 用户名登录
    'smsLogin': true, // 短信验证码登录
    'emailCodeLogin': true, // 邮箱验证码登录
    'wxQRCodeLogin': true // 是否支持微信登录
  },
  'forgetPwdEnabled': true, // 忘记密码
  'isRegisterEnabled': true, // 有利也的立即注册按钮
  'isHelpCenterEnabled': true, // 登录页邮编的指引按钮
  'tiledLogo': null,
  'leftLogo': null,
  'rightLogo': null,
  'sfInternationalLogo': null,
  'tiledEnable': true,
  'leftDocuments': {
    'lang': '', // 语言
    'jumpUrl': '', // 跳转链接
    'jumpDocument': '', // 二维码
    'describe': '', // 描述
    'scanningWarn': '', // 扫描提示
    'codeLogo': '', // qrcode
  }
}

const iscoConfig = {
  'isOldLoginOn': true, // 老登录页
  'cooperationConsulting': true, // 合作咨询
  'internationalWebsite': true, // 国际官网
  'country': true, // 国家
  'language': true, // 语言
  'officialWebsiteLogoText': {
    'default': 'ISCO',
    'zh-CN': '国际供应链订单系统',
    'zh-HK': '國際供應鏈訂單系統',
    'en': 'ISCO',
    'ja-JP': 'ISCO',
    'ko-KR': 'ISCO',
    'th-TH': 'ISCO',
    'vi-VN': 'ISCO'
  },
  'loginMethods': {
    'mobilePhoneLogin': true, // 手机号登录
    'emailLogin': true, // 邮箱密码登录
    'usernameLogin': true, // 用户名登录
    'smsLogin': true, // 短信验证码登录
    'emailCodeLogin': true, // 邮箱验证码登录
    'wxQRCodeLogin': true // 是否支持微信登录
  },
  'forgetPwdEnabled': true, // 忘记密码
  'isRegisterEnabled': true, // 有利也的立即注册按钮
  'isHelpCenterEnabled': true, // 登录页邮编的指引按钮
  'tiledLogo': null,
  'leftLogo': null,
  'rightLogo': null,
  'sfInternationalLogo': null,
  'tiledEnable': true,
  'leftDocuments': {
    'lang': '', // 语言
    'jumpUrl': '', // 跳转链接
    'jumpDocument': '', // 二维码
    'describe': '', // 描述
    'scanningWarn': '', // 扫描提示
    'codeLogo': '', // qrcode
  },
  sfTheme: true
}

const iftpConfig = {
  'isOldLoginOn': true, // 老登录页
  'cooperationConsulting': true, // 合作咨询
  'internationalWebsite': true, // 国际官网
  'country': true, // 国家
  'language': true, // 语言
  'officialWebsiteLogoText': {
    'default': 'IFTP',
    'zh-CN': '国际货运平台',
    'zh-HK': '國際貨運平臺',
    'en': 'IFTP',
    'ja-JP': 'IFTP',
    'ko-KR': 'IFTP',
    'th-TH': 'IFTP',
    'vi-VN': 'IFTP'
  },
  'loginMethods': {
    'mobilePhoneLogin': true, // 手机号登录
    'emailLogin': true, // 邮箱密码登录
    'usernameLogin': true, // 用户名登录
    'smsLogin': true, // 短信验证码登录
    'emailCodeLogin': true, // 邮箱验证码登录
    'wxQRCodeLogin': true // 是否支持微信登录
  },
  'forgetPwdEnabled': true, // 忘记密码
  'isRegisterEnabled': true, // 有利也的立即注册按钮
  'isHelpCenterEnabled': true, // 登录页邮编的指引按钮
  'tiledLogo': null,
  'leftLogo': null,
  'rightLogo': null,
  'sfInternationalLogo': null,
  'tiledEnable': true,
  'leftDocuments': {
    'lang': '', // 语言
    'jumpUrl': '', // 跳转链接
    'jumpDocument': '', // 二维码
    'describe': '', // 描述
    'scanningWarn': '', // 扫描提示
    'codeLogo': '', // qrcode
  }
}

const sfbuyConfig = {
  'isOldLoginOn': true, // 老登录页
  'cooperationConsulting': true, // 合作咨询
  'internationalWebsite': true, // 国际官网
  'country': true, // 国家
  'language': true, // 语言
  'officialWebsiteLogoText': {
    'default': 'SFBuy',
    'zh-CN': '顺丰集运',
    'zh-HK': '順豐集運',
    'en': 'SFBuy',
    'ja-JP': 'SFBuy',
    'ko-KR': 'SFBuy',
    'th-TH': 'SFBuy',
    'vi-VN': 'SFBuy'
  },
  'loginMethods': {
    'mobilePhoneLogin': true, // 手机号登录
    'emailLogin': true, // 邮箱密码登录
    'usernameLogin': true, // 用户名登录
    'smsLogin': true, // 短信验证码登录
    'emailCodeLogin': true, // 邮箱验证码登录
    'wxQRCodeLogin': true // 是否支持微信登录
  },
  'forgetPwdEnabled': true, // 忘记密码
  'isRegisterEnabled': true, // 有利也的立即注册按钮
  'isHelpCenterEnabled': true, // 登录页邮编的指引按钮
  'tiledLogo': null,
  'leftLogo': null,
  'rightLogo': null,
  'sfInternationalLogo': null,
  'tiledEnable': true,
  'leftDocuments': {
    'lang': '', // 语言
    'jumpUrl': '', // 跳转链接
    'jumpDocument': '', // 二维码
    'describe': '', // 描述
    'scanningWarn': '', // 扫描提示
    'codeLogo': '', // qrcode
  }
}

const iuopConfig = {
  'isOldLoginOn': false, // 老登录页
  'cooperationConsulting': true, // 合作咨询
  'internationalWebsite': true, // 国际官网
  'country': true, // 国家
  'language': true, // 语言
  'officialWebsiteLogoText': {
    'default': 'IUOP',
    'zh-CN': '国际统一订单平台',
    'zh-HK': '國際統一訂單平臺',
    'en': 'IUOP',
    'ja-JP': 'IUOP',
    'ko-KR': 'IUOP',
    'th-TH': 'IUOP',
    'vi-VN': 'IUOP'
  },
  'loginType': 0, // 0 融合登录 1 3要素分开登录
  'loginMethods': {
    'mobilePhoneLogin': true, // 手机号登录
    'emailLogin': true, // 邮箱密码登录
    'usernameLogin': true, // 用户名登录
    'smsLogin': true, // 短信验证码登录
    'emailCodeLogin': true, // 邮箱验证码登录
    'wxQRCodeLogin': true // 是否支持微信登录
  },
  'forgetPwdEnabled': true, // 忘记密码
  'isRegisterEnabled': true, // 有利也的立即注册按钮
  'isHelpCenterEnabled': true, // 登录页邮编的指引按钮
  'tiledLogo': null,
  'leftLogo': null,
  'rightLogo': null,
  'sfInternationalLogo': null,
  'tiledEnable': true,
  'leftDocuments': {
    'lang': '', // 语言
    'jumpUrl': '', // 跳转链接
    'jumpDocument': '', // 二维码
    'describe': '', // 描述
    'scanningWarn': '', // 扫描提示
    'codeLogo': '', // qrcode
  }
}

const iuopBoschConfig = {
  'isOldLoginOn': false, // 老登录页
  'cooperationConsulting': true, // 合作咨询
  'internationalWebsite': true, // 国际官网
  'country': true, // 国家
  'language': true, // 语言
  'officialWebsiteLogoText': {
    'default': 'BOSCH',
    'zh-CN': 'BOSCH',
    'zh-HK': 'BOSCH',
    'en': 'BOSCH',
    'ja-JP': 'BOSCH',
    'ko-KR': 'BOSCH',
    'th-TH': 'BOSCH',
    'vi-VN': 'BOSCH'
  },
  'loginType': 0, // 0 融合登录 1 3要素分开登录
  'loginMethods': {
    'mobilePhoneLogin': true, // 手机号登录
    'emailLogin': true, // 邮箱密码登录
    'usernameLogin': true, // 用户名登录
    'smsLogin': true, // 短信验证码登录
    'emailCodeLogin': true, // 邮箱验证码登录
    'wxQRCodeLogin': true // 是否支持微信登录
  },
  'forgetPwdEnabled': true, // 忘记密码
  'isRegisterEnabled': true, // 有利也的立即注册按钮
  'isHelpCenterEnabled': true, // 登录页邮编的指引按钮
  'tiledLogo': null,
  'leftLogo': null,
  'rightLogo': null,
  'sfInternationalLogo': null,
  'tiledEnable': true,
  'leftDocuments': {
    'lang': '', // 语言
    'jumpUrl': '', // 跳转链接
    'jumpDocument': '', // 二维码
    'describe': '', // 描述
    'scanningWarn': '', // 扫描提示
    'codeLogo': '', // qrcode
  }
}
const glsConfig = {
  'isOldLoginOn': false, // 老登录页
  'cooperationConsulting': true, // 合作咨询
  'internationalWebsite': true, // 国际官网
  'country': false, // 国家
  'language': true, // 语言
  'officialWebsiteLogoText': {
    'default': 'Global League System',
    'zh-CN': 'GLS 海外联盟',
    'zh-HK': 'GLS 海外連盟',
    'en': 'Global League System',
    'ja-JP': 'GLS 海外連盟',
    'ko-KR': 'Global League System',
    'th-TH': 'Global League System',
    'vi-VN': 'Global League System'
  },
  'loginType': 0, // 0 融合登录 1 3要素分开登录
  'loginMethods': {
    'mobilePhoneLogin': false, // 手机号登录
    'emailLogin': false, // 邮箱密码登录
    'usernameLogin': true, // 用户名登录
    'smsLogin': false, // 短信验证码登录
    'emailCodeLogin': false, // 邮箱验证码登录
    'wxQRCodeLogin': false // 是否支持微信登录
  },
  'forgetPwdEnabled': true, // 忘记密码
  'isRegisterEnabled': false, // 有利也的立即注册按钮
  'isHelpCenterEnabled': false, // 登录页邮编的指引按钮
  'tiledLogo': null,
  'leftLogo': null,
  'rightLogo': null,
  'sfInternationalLogo': null,
  'tiledEnable': true,
  'leftDocuments': {
    'lang': '', // 语言
    'jumpUrl': '', // 跳转链接
    'jumpDocument': '', // 二维码
    'describe': '', // 描述
    'scanningWarn': '', // 扫描提示
    'codeLogo': '', // qrcode
  }
}

const acsConfig = {
  'isOldLoginOn': false, // 老登录页
  'cooperationConsulting': true, // 合作咨询
  'internationalWebsite': true, // 国际官网
  'country': false, // 国家
  'language': true, // 语言
  'officialWebsiteLogoText': {
    'default': 'Agent Collaboration System',
    'zh-CN': 'ACS 代理协同系统',
    'zh-HK': 'ACS代理協同系統',
    'en': 'Agent Collaboration System',
    'ja-JP': 'ACS代理協同システム',
    'ko-KR': 'Agent Collaboration System',
    'th-TH': 'Agent Collaboration System',
    'vi-VN': 'Agent Collaboration System'
  },
  'loginType': 0, // 0 融合登录 1 3要素分开登录
  'loginMethods': {
    'mobilePhoneLogin': false, // 手机号登录
    'emailLogin': false, // 邮箱密码登录
    'usernameLogin': true, // 用户名登录
    'smsLogin': false, // 短信验证码登录
    'emailCodeLogin': false, // 邮箱验证码登录
    'wxQRCodeLogin': false // 是否支持微信登录
  },
  'forgetPwdEnabled': true, // 忘记密码
  'isRegisterEnabled': false, // 有利也的立即注册按钮
  'isHelpCenterEnabled': false, // 登录页邮编的指引按钮
  'tiledLogo': null,
  'leftLogo': null,
  'rightLogo': null,
  'businessSystemLogo': null,
  'sfInternationalLogo': null,
  'tiledEnable': true,
  'leftDocuments': {
    'lang': '', // 语言
    'jumpUrl': '', // 跳转链接
    'jumpDocument': '', // 二维码
    'describe': '', // 描述
    'scanningWarn': '', // 扫描提示
    'codeLogo': '', // qrcode
  }
}

const cairConfig = {
  termsOfServiceKey: 122,
  privacyPolicyKey: 121,
  cookieKey: 123,
  'isOldLoginOn': false, // 老登录页
  'cooperationConsulting': true, // 合作咨询
  'internationalWebsite': true, // 国际官网
  'country': true, // 国家
  'language': true, // 语言
  'officialWebsiteLogoText': {
    'default': '',
    'zh-CN': '',
    'zh-HK': '',
    'en': '',
    'ja-JP': '',
    'ko-KR': '',
    'th-TH': '',
    'vi-VN': ''
  },
  'loginType': 0, // 0 融合登录 1 3要素分开登录
  'loginMethods': {
    'mobilePhoneLogin': true, // 手机号登录
    'emailLogin': true, // 邮箱密码登录
    'usernameLogin': true, // 用户名登录
    'smsLogin': true, // 短信验证码登录
    'emailCodeLogin': true, // 邮箱验证码登录
    'wxQRCodeLogin': true // 是否支持微信登录
  },
  'forgetPwdEnabled': true, // 忘记密码
  'isRegisterEnabled': true, // 有利也的立即注册按钮
  'isHelpCenterEnabled': true, // 登录页邮编的指引按钮
  'tiledLogo': null,
  'leftLogo': null,
  'rightLogo': null,
  'sfInternationalLogo': null,
  'tiledEnable': true,
  'leftDocuments': {
    'lang': '', // 语言
    'jumpUrl': '', // 跳转链接
    'jumpDocument': '', // 二维码
    'describe': '', // 描述
    'scanningWarn': '', // 扫描提示
    'codeLogo': '', // qrcode
  }

}

export {
  config,
  sdmConfig,
  ESGOSConfig,
  cbsConfig,
  iftpConfig,
  iuopConfig,
  openAPIConfig,
  sfbuyConfig,
  glsConfig,
  iscoConfig,
  acsConfig,
  iuopBoschConfig,
  cairConfig,
  IUOPOSconfig,
  IUOPOSIDconfig
}
